module.exports = __webpack_public_path__ + "static/ReferIllustrationn-6a754ae500668ab20fcd77cece450c3c.svg";